import { useMemo } from 'react';

import { useOptimizedLocation } from './useOptimizedLocation';

export const useLocationKey = () => {
  const { locationState, isLocationReady, hasLocationToken } = useOptimizedLocation();

  const locationKey = useMemo(() => {
    if (!isLocationReady) return 'loading';
    if (!hasLocationToken) return 'no-token';
    return locationState || 'unknown';
  }, [locationState, isLocationReady, hasLocationToken]);

  return {
    locationKey,
    isLocationReady,
    hasLocationToken,
    locationState,
  };
};
